export default "__VITE_ASSET__Dgg7ptYo__"